export default function getPointsPerPip(data: InstrumentData | undefined) {
  /**
   * @param  {InstrumentData} data Datos del instrumento.
   * @return {number} Cuántos puntos equivalen a un pip.
   *
   * MT5 entrega swap y spread "en puntos" (la última cifra decimal del precio).
   * El pip_value es por pip. Para pares forex el pip está en la 2da decimal
   * (pares JPY) o en la 4ta (resto), por convención. Si el precio trae un dígito
   * fraccional extra (ej. 5 decimales en vez de 4, o 3 en vez de 2), 1 pip = 10
   * puntos y hay que convertir puntos→pips dividiendo el swap/spread por este factor.
   *
   * Devuelve 1 (sin conversión) para todo lo que no sea un par forex estándar:
   * commodities, acciones, cripto y pares con CLP usan otra lógica de pip.
   *
   * EURUSD (margin EUR / base USD) también devuelve 1: su pip_value ya se
   * sobrescribe en getPipValue a 1/buy_price, que combinado con usdValue (= el
   * precio del par) equivale al valor "por punto", no por pip. Dividir aquí por
   * el factor duplicaría la conversión y dejaría el swap 10x más chico.
   */

  if (data === undefined) return 1
  if (data.market.trim() !== "forex") return 1
  if (data.base_currency === "CLP" || data.margin_currency === "CLP") return 1
  if (data.margin_currency === "EUR" && data.base_currency === "USD") return 1

  const decimals = String(data.buy_price).replace(",", ".").split(".")[1]?.length ?? 0
  if (decimals === 0) return 1

  const pipDecimals = data.base_currency === "JPY" ? 2 : 4
  const factor = Math.pow(10, decimals - pipDecimals)

  return factor >= 1 ? factor : 1
}
